import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import Cookies from 'js-cookie';

class ProjectLinkService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.PROJECT_LINK = '/api/project-link';
    
        this.GET_BY_ID = '/{id}';
        this.GET_LIST_FOR_PROJECT = '/list/project/{projectId}';
        this.GET_LIST_FOR_PROJECT_AND_LINK_TYPE = '/list/project/{projectId}/linkType/{linkType}';
        this.GET_BY_PROJECT_ID_AND_LINK_TYPE_AND_LINK_TARGET = '/project/{projectId}/linkType/{linkType}/linkTarget/{linkTarget}';
        this.EXISTS_BY_PROJECT_ID_AND_LINK_TYPE_AND_LINK_TARGET = '/exists/project/{projectId}/linkType/{linkType}/linkTarget/{linkTarget}';

    }

    async getProjectLinkById(id) {
        try {
            let url = window.location.origin + this.PROJECT_LINK + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectLinkListByProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT_LINK + this.GET_LIST_FOR_PROJECT;
            url = url
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectLinkListByProjectAndLinkType(projectId, linkType) {
        try {
            let url = window.location.origin + this.PROJECT_LINK + this.GET_LIST_FOR_PROJECT_AND_LINK_TYPE;
            url = url
                .replace('{projectId}', projectId)
                .replace('{linkType}', linkType);
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectLinkByProjectIdAndLinkTypeAndLinkTarget(projectId, linkType, linkTarget) {
        try {
            let url = window.location.origin + this.PROJECT_LINK + this.GET_BY_PROJECT_ID_AND_LINK_TYPE_AND_LINK_TARGET;
            url = url
                .replace('{projectId}', projectId)
                .replace('{linkType}', linkType)
                .replace('{linkTarget}', linkTarget);
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async existsProjectLinkByProjectIdAndLinkTypeAndLinkTarget(projectId, linkType, linkTarget) {
        try {
            let url = window.location.origin + this.PROJECT_LINK + this.EXISTS_BY_PROJECT_ID_AND_LINK_TYPE_AND_LINK_TARGET;
            url = url
                .replace('{projectId}', projectId)
                .replace('{linkType}', linkType)
                .replace('{linkTarget}', linkTarget);
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async createProjectLink(projectLink) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_LINK;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectLink)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateProjectLink(projectLink) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_LINK;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectLink)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteProjectLink(projectLinkId){
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_LINK;
        let deleteEpicData = {
            'projectLinkId': projectLinkId
        };
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                    },
                body: JSON.stringify(deleteEpicData)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }
}

export default ProjectLinkService;
